import React, {useEffect, useRef, useState} from "react";
import {useDispatch} from "react-redux";
import {
  clearButtonProcessing,
  resetAlert,
  setAlertSuccess,
  setButtonProcessing
} from "../../store/actions";
import {
  ErrorMessageAlert,
  FormGroupVerticalInput,
  TextInput
} from "../../components";
import {
  errorStatusHandle,
  getAlertErrorMessage,
  getFormErrorResponseData,
  getInputErrorMessage, getNameFromPreSignedUrl, hasErrorInput,
} from "../../utils";
import {createOrUpdateInspectionMethod} from "../../api/inspetionItemApi";
import {Button} from "../../components";
import CollapseExpanded from "../CollapseExpanded";
import {hasErrors} from "../../utils/group-option-utils";
import Table from "../table/Table";
import * as pdfjslib from "pdfjs-dist/webpack";
import {renderPdfToImage} from "../../utils/common-utils"
import _ from "lodash";
import Modal from "../modal/Modal";
import {getInspectionJudgment} from "../../utils/display-utils";
import {useDropzone} from "react-dropzone";
import {FiDownloadCloud} from "react-icons/fi";

function InspectionMethodDetails({openModal, setOpenModal, modalData, setModalData}) {
  const dispatch = useDispatch();

  const [inputs, setInputs] = useState({});
  const [errorMessages, setErrorMessages] = useState({});
  const [data, setData] = useState({});
  const [isExpanded1, setExpanded1] = useState(true);
  const [isExpanded2, setExpanded2] = useState(true);
  const [isExpanded3, setExpanded3] = useState(true);
  const imageInputRef = useRef();
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageInfo, setImageInfo] = useState(null);

  useEffect(() => {
    setData(modalData);
    setInputs({ template_id: modalData?.template_id, inspection_items: {} });
  }, [modalData])

  useEffect(() => {
    generateImageUrl();
  }, [selectedImage, modalData])

  const generateImageUrl = () => {
    if (selectedImage) {
      setImageInfo({url: URL.createObjectURL(selectedImage), name: selectedImage.name});
    } else if (data?.template?.remark_image) {
      setImageInfo(
        {
          url: data.template.remark_image,
          name: getNameFromPreSignedUrl(data.template.remark_image)
        }
      );
    } else {
      setImageInfo(null);
    }
  };

  const handleClick = (e) => {
    imageInputRef.current.click();
  };
  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      const acceptedExtensions = ['image/jpg', 'image/png', 'image/gif', 'application/pdf'];
      if (acceptedExtensions.includes(file.type)) {
        if (file.type === 'application/pdf') {
          const fileReader = new FileReader();
          fileReader.onload = async function () {
            const typedArray = new Uint8Array(this.result);
            const pdf = await pdfjslib.getDocument(typedArray).promise;
            const pdfImageFileName = file.name.replace(".pdf", "");
            const getFileImagePDF = await renderPdfToImage(pdf, pdfImageFileName);
            setSelectedImage(getFileImagePDF);
            ;
            setInputs((prevData) => ({ ...prevData, remark_image: getFileImagePDF }));
            setData({
              ...data,
              [e.target.name]: 'favicon.ico'
            });
          };
          fileReader.readAsArrayBuffer(file);
        } else {
          setSelectedImage(file);
          setInputs((prevData) => ({ ...prevData, remark_image: file }));
        }
      } else {
        alert("拡張子がPG,GIF,PNG,PDF以外のファイルをアップロードすることは出来ません。");
      }
    }
  };
  const onDrop = React.useCallback(
    (acceptedFile) => {
      if (acceptedFile.length > 0) {
        const file = acceptedFile[0];
        setSelectedImage(file);
        setInputs((prevData) => ({ ...prevData, remark_image: file }));
      }
    },
    []
  );

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    multiple: false,
  });

  const handleUploadImage = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedFileTypes = ['image/jpg', 'image/png', 'image/gif', 'application/pdf'];
      if (!allowedFileTypes.includes(file.type)) {
        alert('拡張子がJPG,GIF,PNG,PDF以外のファイルをアップロードすることは出来ません。');
        return;
      }
      if (file.size > (5 * 1024 * 1024)) {
        alert('ファイルの合計サイズが5MBを超えています。');
        return;
      }
      if (file.type === 'application/pdf') {
        const fileReader = new FileReader();
        fileReader.onload = async function () {
          const typedArray = new Uint8Array(this.result);
          const pdf = await pdfjslib.getDocument(typedArray).promise;
          const pdfImageFileName = file.name.replace(".pdf", "");
          const getFileImagePDF = await renderPdfToImage(pdf, pdfImageFileName);
          setSelectedImage(getFileImagePDF);
          setInputs((prevData) => ({ ...prevData, remark_image: getFileImagePDF }));
          setData({
            ...data,
            [event.target.name]: 'favicon.ico'
          });
        };
        fileReader.readAsArrayBuffer(file);
      } else {
        setSelectedImage(file);
        setInputs((prevData) => ({ ...prevData, remark_image: file }));
        setData({
          ...data,
          [event.target.name]: 'favicon.ico'
        });
      }
    }
  };

  // Function to handle changes in input
  const onChange = (e, fieldName, itemId = undefined) => {
    dispatch(resetAlert());
    let value = e.target.value;
    if (itemId === undefined) {
      setData((prevData) => ({
        ...prevData,
        template: { ...prevData.template, [fieldName]: value}
      }));
      setInputs((prevData) => ({ ...prevData, [fieldName]: value }));
    } else {
      setData((prevData) => ({
        ...prevData,
        inspection_items: prevData.inspection_items.map((item) =>
          item.id === itemId ? { ...item, [fieldName]: value } : item
        ),
      }));
      setInputs((prevData) => ({
        ...prevData,
        inspection_items: {...prevData.inspection_items, [itemId]: {...prevData.inspection_items[itemId], [fieldName]: value}}
      }));
    }
  };

  // Function to handle closing modal
  const handleClose = () => {
    setData(modalData);
    setInputs({ template_id: modalData?.template_id, inspection_items: {} });
    setSelectedImage(null);
    setErrorMessages({});
    setOpenModal(false);
  };

  // Function to handle update inspection method
  const updateInspectionMethod = async (e, buttonId) => {
    e.preventDefault();
    dispatch(resetAlert());
    dispatch(setButtonProcessing(buttonId));
    await createOrUpdateInspectionMethod(inputs).then(
      (response) => {
        dispatch(setAlertSuccess(response.message));
        const responseData = {
          template_id: data.template_id,
          template: response.data.template,
          inspection_items: response.data.inspection_items
        };
        setModalData(responseData);
        setData(responseData);
        setInputs({ template_id: modalData?.template_id, inspection_items: {} });
        setErrorMessages({});
        setOpenModal(false);
      }
    ).catch(e => {
      errorStatusHandle(e.response);
      if (e.response.status === 400) {
        let errorResponse = getFormErrorResponseData(e);
        if (errorResponse) {
          setErrorMessages(errorResponse);
        }
      }
    }).finally(() => {
      dispatch(clearButtonProcessing(buttonId));
    });
  };

  const getTableErrorMessages = () => {
    if (_.isEmpty(errorMessages)) return;
    const errorItems = [];
    if (!_.isEmpty(errorMessages.errors) && errorMessages.errors.hasOwnProperty('inspection_items')) {
      const errors = errorMessages.errors.inspection_items;
      let messages = new Set();
      for (const key in errors) {
        const errs = errors[key];
        for (const errKey in errs) {
          messages.add("・" + errs[errKey]);
        }
      }
      messages = Array.from(messages);
      if (messages.length > 0) {
        errorItems.push(...messages);
      }
    }
    return errorItems;
  };

  return (
    <Modal show={openModal} onClose={() => handleClose()} size="7xl">
      <Modal.Header>点検方法詳細</Modal.Header>
      <Modal.Body className="p-[20px] bg-[#F2F4F7]">

        <ErrorMessageAlert className="mb-[16px]" error={getAlertErrorMessage(errorMessages)}/>

        <div className="flex flex-col gap-[16px]">
          <div className="flex flex-col px-[10px] py-[14px] bg-white rounded-lg border border-[#D0D5DD]">
            <CollapseExpanded title="備考" isExpanded={isExpanded1} setExpanded={setExpanded1}>
              <div className="flex flex-col gap-[16px] mt-[16px] border-t border-[#D0D5DD] pt-[10px]">
                <div className="flex">
                  <div className="p-4 w-1/2">
                    <label className="text-base font-normal text-gray-700 mb-2" htmlFor='remark_text_1'>点検方法補足1</label>
                    <FormGroupVerticalInput error={getInputErrorMessage(errorMessages.errors, "remark_text_1")}>
                      <textarea
                        className={`w-full border ${hasErrorInput(errorMessages, "remark_text_1") ? ' border-red-500' : ' border-[#D0D5DD]'} focus:bg-yellow-100 focus:border-gray-500 focus:ring-0 focus:border-[#D0D5DD]`}
                        name="remark_text_1" id="remark_text_1" rows="4"
                        value={data?.template?.remark_text_1 || ''}
                        maxLength={500} autoFocus
                        onChange={(e) => onChange(e, "remark_text_1")}
                      />
                    </FormGroupVerticalInput>
                  </div>
                  <div className="p-4 w-1/2">
                    <label className="text-base font-normal text-gray-700 mb-2" htmlFor="remark_text_2">点検方法補足2</label>
                    <FormGroupVerticalInput error={getInputErrorMessage(errorMessages.errors, "remark_text_2")}>
                      <textarea
                        className={`w-full border ${hasErrorInput(errorMessages, "remark_text_2") ? ' border-red-500' : ' border-[#D0D5DD]'} focus:bg-yellow-100 focus:border-gray-500 focus:ring-0 focus:border-[#D0D5DD]`}
                        name="remark_text_2" id="remark_text_2" rows="4"
                        value={data?.template?.remark_text_2 || ''}
                        maxLength={500}
                        onChange={(e) => onChange(e, "remark_text_2")}
                      />
                    </FormGroupVerticalInput>
                  </div>
                </div>
              </div>
            </CollapseExpanded>
          </div>
          <div className="flex flex-col px-[10px] py-[14px] bg-white rounded-lg border border-[#D0D5DD]">
            <CollapseExpanded title="点検方法付図" isExpanded={isExpanded2} setExpanded={setExpanded2}>
              <div className="flex flex-col mt-[16px] border-t border-[#D0D5DD] p-4 pt-[10px]">
                <span className="font-light">画像のアップロードが可能です</span>
                <span className="mb-[10px]">画像 5MB以内 JPG,GIF,PNG,PDFのみ</span>
                <FormGroupVerticalInput error={getInputErrorMessage(errorMessages.errors, "remark_image")}>
                  <div {...getRootProps()}
                      onClick={handleClick}
                      onDragEnter={handleDragEnter}
                      onDragLeave={handleDragLeave}
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                      className={`bg-[#f5f8fe] rounded-[8px] outline outline-2 outline-dashed outline-[#BDBDBD] border item-center cursor-pointer flex flex-col justify-center item-center h-[300px] before:border-dotted`}
                  >
                    {imageInfo ? (
                      <div className="h-full">
                        <img src={imageInfo.url}
                             alt="remark_image"
                             className="h-full w-auto object-cover p-2"/>
                      </div>
                      ) :
                      <div className="flex flex-col gap-[8px]">
                        <FiDownloadCloud className="mx-auto" size="60" color="#BDBDBD"/>
                        <p className="font-normal xl:text-[18px] md:text-[16px] text-center">
                          ここにファイルをドラッグ＆ドロップ
                        </p>
                        <p className="font-light xl:text-[16px] md:text-[15px] text-center">または</p>
                        <div className="flex justify-center">
                          <Button type="button"
                                  color="purple"
                                  className="upload-file__btn min-w-[160px] max-w-[200px] w-full"
                          >ファイルを選択</Button>
                        </div>
                      </div>
                    }
                  </div>
                  <input type="file"
                         {...getInputProps()}
                         ref={imageInputRef}
                         accept=".svg,.png,.jpg,.pdf,.gif"
                         onChange={handleUploadImage}
                         className="hidden"
                         name="remark_image"
                         id="remark_image"/>
                </FormGroupVerticalInput>
              </div>
            </CollapseExpanded>
          </div>
          <div className="flex flex-col px-[10px] py-[14px] bg-white rounded-lg border border-[#D0D5DD]">
            <CollapseExpanded title="点検箇所 - 確認方法" isExpanded={isExpanded3} setExpanded={setExpanded3}>
              <div className="flex flex-col gap-[16px] mt-[16px] border-t border-[#D0D5DD] pt-[16px]">
                <ErrorMessageAlert error={getTableErrorMessages()}/>
                <div className="template-management__table mt-0">
                  <Table striped>
                    <Table.Head className="text-base">
                      <Table.HeadCell className="bg-tenken-gray-300 w-[20px]"/>
                      <Table.HeadCell className="bg-tenken-gray-300">
                        <div className="flex items-center whitespace-nowrap normal-case">点検項目</div>
                      </Table.HeadCell>
                      <Table.HeadCell className="bg-tenken-gray-300 w-[180px]">
                        <div className="flex items-center whitespace-nowrap">点検箇所</div>
                      </Table.HeadCell>
                      <Table.HeadCell className="bg-tenken-gray-300 w-[180px]">
                        <div className="flex items-center whitespace-nowrap">確認方法</div>
                      </Table.HeadCell>
                      <Table.HeadCell className="bg-tenken-gray-300">
                        <div className="flex items-center whitespace-nowrap">下限</div>
                      </Table.HeadCell>
                      <Table.HeadCell className="bg-tenken-gray-300">
                        <div className="flex items-center whitespace-nowrap">上限</div>
                      </Table.HeadCell>
                      <Table.HeadCell className="bg-tenken-gray-300"/>
                      <Table.HeadCell className="bg-tenken-gray-300 w-[250px]">
                        <div className="flex items-center whitespace-nowrap normal-case">判定基準</div>
                      </Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="text-base">
                      {data?.inspection_items && data?.inspection_items.map((row, index) => (
                        <Table.Row key={index}>
                          <Table.Cell className="py-1 xl:py-2">{index + 1}</Table.Cell>
                          <Table.Cell className="py-1 xl:py-2">
                            <div className="flex items-center whitespace-nowrap text-tenken-gray-900">
                              <span>{row.title}</span>
                            </div>
                          </Table.Cell>
                          <Table.Cell className="py-1 xl:py-2">
                            <div className="flex items-center whitespace-nowrap text-tenken-gray-900">
                              <TextInput type="text" maxLength={100}
                                         value={row.inspection_point || ''} name="inspection_point"
                                         hasError={
                                           hasErrors(
                                             "inspection_point",
                                             errorMessages.errors?.inspection_items?.[row.id]
                                           )
                                         }
                                         onChange={(e) => {
                                           onChange(e, "inspection_point", row.id)
                                         }}
                                         className="w-full inline-block !h-[38px]"/>
                            </div>
                          </Table.Cell>
                          <Table.Cell className="py-1 xl:py-2">
                            <div className="flex items-center whitespace-nowrap text-tenken-gray-900">
                              <TextInput type="text" maxLength={100}
                                         value={row.inspection_method || ''} name="inspection_method"
                                         hasError={
                                           hasErrors(
                                             "inspection_method",
                                             errorMessages.errors?.inspection_items?.[row.id]
                                           )
                                         }
                                         onChange={(e) => {
                                           onChange(e, "inspection_method", row.id)
                                         }}
                                         className="w-full inline-block !h-[38px]"/>
                            </div>
                          </Table.Cell>
                          <Table.Cell className="py-1 xl:py-2">
                            <div className="flex items-center whitespace-nowrap">
                              <span>
                                {getInspectionJudgment(
                                  row.inspection_judgment?.lower_value,
                                  row.inspection_judgment?.lower_boundary_type,
                                  row.unit,
                                  'lower'
                                )}</span>
                            </div>
                          </Table.Cell>
                          <Table.Cell className="py-1 xl:py-2">
                            <div className="flex items-center whitespace-nowrap">
                              <span>
                                {getInspectionJudgment(
                                  row.inspection_judgment?.upper_value,
                                  row.inspection_judgment?.upper_boundary_type,
                                  row.unit,
                                  'upper'
                                )}</span>
                            </div>
                          </Table.Cell>
                          <Table.Cell className="py-1 xl:py-2">
                            <div className="flex items-center whitespace-nowrap">
                              <span>{row.unit ? `(${row.unit})` : '-'}</span>
                            </div>
                          </Table.Cell>
                          <Table.Cell className="py-1 xl:py-2">
                            <div className="flex items-center">
                              <span>{row.description}</span>
                            </div>
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </div>
              </div>
            </CollapseExpanded>
          </div>
        </div>

      </Modal.Body>
      <Modal.Footer className="flex justify-center h-[76px] border-tenken-gray-200 bg-white space-x-[60px] px-[100px]">
        <Button color="light" className="w-1/2" onClick={() => handleClose()}>閉じる</Button>
        <Button color="yellow" className="w-1/2" id='btn-inspection-method'
                onClick={(e) => updateInspectionMethod(e, 'btn-inspection-method')}>
          更新</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default InspectionMethodDetails;